<div class="search-banner">
  <nav class="search-banner__category-selection-bar">
    <ul nz-menu nzMode="horizontal" class="search-banner__menu">
      <li nz-menu-item>
        <a class="search-banner__menu-item" [routerLink]="['/category/pc']">
          <span
            class="search-banner__icon"
            nz-icon
            nzType="ng-zorro:pc"
            aria-hidden="true"
          ></span>
          <span class="search-banner__name">PC</span>
        </a>
      </li>
      <li nz-menu-item>
        <a
          class="search-banner__menu-item"
          [routerLink]="['/category/playstation']"
        >
          <span
            class="search-banner__icon"
            nz-icon
            nzType="ng-zorro:playstation"
            aria-hidden="true"
          ></span>
          <span class="search-banner__name">Play Station</span>
        </a>
      </li>
      <li nz-menu-item>
        <a class="search-banner__menu-item" [routerLink]="['/category/xbox']">
          <span
            class="search-banner__icon"
            nz-icon
            nzType="ng-zorro:xbox"
            aria-hidden="true"
          ></span>
          <span class="search-banner__name">Xbox</span>
        </a>
      </li>
      <li nz-menu-item>
        <a
          class="search-banner__menu-item"
          [routerLink]="['/category/nintendo']"
        >
          <span
            class="search-banner__icon"
            nz-icon
            nzType="ng-zorro:nintendo"
            aria-hidden="true"
          ></span>
          <span class="search-banner__name">Nintendo</span>
        </a>
      </li>
      <li nz-menu-item>
        <a
          class="search-banner__menu-item"
          [routerLink]="['/category/giftcards']"
        >
          <span
            class="search-banner__icon"
            nz-icon
            nzType="ng-zorro:giftcards"
            aria-hidden="true"
          ></span>
          <span class="search-banner__name">Gift Cards</span>
        </a>
      </li>
    </ul>
    <button
      class="search-banner__search-btn"
      (click)="toggleSearch()"
      [ngClass]="{ 'search-banner__search-btn--hidden': isOpen }"
      aria-label="Open search"
    >
      <span nz-icon nzType="ng-zorro:magnifier" aria-hidden="true"></span>
    </button>
    <input
      type="search"
      id="search-input"
      [(ngModel)]="query"
      class="search-banner__input"
      [ngClass]="{ 'search-banner__input--open': isOpen }"
      (keyup.enter)="navigate()"
      #searchInput
      aria-label="Search"
    />
  </nav>
  <button
    class="search-banner__close-btn"
    (click)="toggleSearch()"
    [ngClass]="{ 'search-banner__close-btn--hidden': !isOpen }"
    aria-label="Close search"
  >
    <span nz-icon nzType="ng-zorro:cross" aria-hidden="true"></span>
  </button>
</div>
